'use es6';

export const DEBOUNCE_DELAY = 500;